var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBaselineMousewheel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 44
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 18084",
    transform: "translate(-226 -720)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 4647",
    transform: "translate(226 720)",
    fill: "none",
    stroke: "#8d89a3",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 44,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 42,
    rx: 13
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 4648",
    width: 2.419,
    height: 9.675,
    rx: 1,
    transform: "translate(238.698 733.303)",
    fill: "#8d89a3"
  }))));
}
export default SvgBaselineMousewheel;